'use-strict';

var SUBTYPE_DEFAULT = 0;
module.exports.SUBTYPE_DEFAULT = SUBTYPE_DEFAULT;

var SUBTYPE_FACEBOOK_PAGE_LIKES = 1;
module.exports.SUBTYPE_FACEBOOK_PAGE_LIKES = SUBTYPE_FACEBOOK_PAGE_LIKES;

var SUBTYPE_INSTAGRAM_STORY = 2;
module.exports.SUBTYPE_INSTAGRAM_STORY = SUBTYPE_INSTAGRAM_STORY;

var SUBTYPE_INSTAGRAM_IGTV = 3;
module.exports.SUBTYPE_INSTAGRAM_IGTV = SUBTYPE_INSTAGRAM_IGTV;

var SUBTYPE_INSTAGRAM_REEL = 3;
module.exports.SUBTYPE_INSTAGRAM_REEL = SUBTYPE_INSTAGRAM_REEL;

var SUBTYPE_INSTAGRAM_SLIDESHOW = 4;
module.exports.SUBTYPE_INSTAGRAM_SLIDESHOW = SUBTYPE_INSTAGRAM_SLIDESHOW;

var SUBTYPE_PINTEREST_PHOTO_EXTENDED = 5;
module.exports.SUBTYPE_PINTEREST_PHOTO_EXTENDED = SUBTYPE_PINTEREST_PHOTO_EXTENDED;

var SUBTYPE_GOOGLE_MY_BUSINESS_EVENT_POST = 7;
module.exports.SUBTYPE_GOOGLE_MY_BUSINESS_EVENT_POST = SUBTYPE_GOOGLE_MY_BUSINESS_EVENT_POST;

var SUBTYPE_GOOGLE_MY_BUSINESS_OFFER_POST = 6;
module.exports.SUBTYPE_GOOGLE_MY_BUSINESS_OFFER_POST = SUBTYPE_GOOGLE_MY_BUSINESS_OFFER_POST;

var SUBTYPE_CAROUSEL = 8;
module.exports.SUBTYPE_CAROUSEL = SUBTYPE_CAROUSEL;

var SUBTYPE = {
  DEFAULT: SUBTYPE_DEFAULT,
  FACEBOOK_PAGE_LIKES: SUBTYPE_FACEBOOK_PAGE_LIKES,
  INSTAGRAM_STORY: SUBTYPE_INSTAGRAM_STORY,
  IGTV: SUBTYPE_INSTAGRAM_IGTV,
  REEL: SUBTYPE_INSTAGRAM_REEL,
  INSTAGRAM_SLIDESHOW: SUBTYPE_INSTAGRAM_SLIDESHOW,
  PINTEREST_PHOTO_EXTENDED: SUBTYPE_PINTEREST_PHOTO_EXTENDED,
  GMB_EVENT_POST: SUBTYPE_GOOGLE_MY_BUSINESS_EVENT_POST,
  GMB_OFFER_POST: SUBTYPE_GOOGLE_MY_BUSINESS_OFFER_POST,
  CAROUSEL: SUBTYPE_CAROUSEL,
};
module.exports.SUBTYPE = SUBTYPE;

var TYPE_COMMENT = 1;
module.exports.TYPE_COMMENT = TYPE_COMMENT;

var TYPE_LINK = 2;
module.exports.TYPE_LINK = TYPE_LINK;

var TYPE_PHOTO = 3;
module.exports.TYPE_PHOTO = TYPE_PHOTO;

var TYPE_GALLERY = 4;
module.exports.TYPE_GALLERY = TYPE_GALLERY;

var TYPE_VIDEO = 5;
module.exports.TYPE_VIDEO = TYPE_VIDEO;

var TYPE_AD = 6;
module.exports.TYPE_AD = TYPE_AD;

var TYPE = {
  COMMENT: TYPE_COMMENT,
  LINK: TYPE_LINK,
  PHOTO: TYPE_PHOTO,
  GALLERY: TYPE_GALLERY,
  VIDEO: TYPE_VIDEO,
  AD: TYPE_AD,
};
module.exports.TYPE = TYPE;

var POST_TYPE_LABEL = {
  [TYPE_COMMENT]: 'Status',
  [TYPE_LINK]: 'Link',
  [TYPE_PHOTO]: 'Photo',
  [TYPE_GALLERY]: 'Gallery',
  [TYPE_VIDEO]: 'Video',
  [TYPE_AD]: 'Ad',
};
module.exports.POST_TYPE_LABEL = POST_TYPE_LABEL;

var STATUS_WAITING_FOR = 1;
module.exports.STATUS_WAITING_FOR = STATUS_WAITING_FOR;

var STATUS_DONE = 2;
module.exports.STATUS_DONE = STATUS_DONE;

var STATUS_WAITING_FOR_INTERNAL_APPROVAL = 3;
module.exports.STATUS_WAITING_FOR_INTERNAL_APPROVAL = STATUS_WAITING_FOR_INTERNAL_APPROVAL;

var STATUS_INTERNAL_APPROVED = 4;
module.exports.STATUS_INTERNAL_APPROVED = STATUS_INTERNAL_APPROVED;

var STATUS_AT_CLIENT = 5;
module.exports.STATUS_AT_CLIENT = STATUS_AT_CLIENT;

var STATUS_APPROVED = 6;
module.exports.STATUS_APPROVED = STATUS_APPROVED;

var STATUS_POSTED = 7;
module.exports.STATUS_POSTED = STATUS_POSTED;

var STATUS_REJECTED = 8;
module.exports.STATUS_REJECTED = STATUS_REJECTED;

var STATUS_REJECTED_BY_CLIENT = 9;
module.exports.STATUS_REJECTED_BY_CLIENT = STATUS_REJECTED_BY_CLIENT;

var STATUS_COMPLETED = 10;
module.exports.STATUS_COMPLETED = STATUS_COMPLETED;

var STATUS_SCHEDULED = 11;
module.exports.STATUS_SCHEDULED = STATUS_SCHEDULED;

var STATUS_DRAFT = 12;
module.exports.STATUS_DRAFT = STATUS_DRAFT;

var STATUS_EXPORT_FAILED = 13;
module.exports.STATUS_EXPORT_FAILED = STATUS_EXPORT_FAILED;

var STATUS_IS_SCHEDULING = 14;
module.exports.STATUS_IS_SCHEDULING = STATUS_IS_SCHEDULING;

var STATUS_EXPORTED = 15;
module.exports.STATUS_EXPORTED = STATUS_EXPORTED;

var STATUS_FAILED = 16;
module.exports.STATUS_FAILED = STATUS_FAILED;

var STATUS = {
  WAITING_FOR: STATUS_WAITING_FOR,
  DONE: STATUS_DONE,
  WAITING_FOR_INTERNAL_APPROVAL: STATUS_WAITING_FOR_INTERNAL_APPROVAL,
  INTERNAL_APPROVED: STATUS_INTERNAL_APPROVED,
  AT_CLIENT: STATUS_AT_CLIENT,
  APPROVED: STATUS_APPROVED,
  POSTED: STATUS_POSTED,
  REJECTED: STATUS_REJECTED,
  REJECTED_BY_CLIENT: STATUS_REJECTED_BY_CLIENT,
  COMPLETED: STATUS_COMPLETED,
  DRAFT: STATUS_DRAFT,
  EXPORT_FAILED: STATUS_EXPORT_FAILED,
  IS_SCHEDULING: STATUS_IS_SCHEDULING,
  SCHEDULED: STATUS_SCHEDULED,
  EXPORTED: STATUS_EXPORTED,
  FAILED: STATUS_FAILED,
};
module.exports.STATUS = STATUS;

var STATUS_COLOR = {
  [STATUS_WAITING_FOR]: '#FF991F',
  [STATUS_DONE]: '#36B37E',
  [STATUS_WAITING_FOR_INTERNAL_APPROVAL]: '#00B8D9',
  [STATUS_INTERNAL_APPROVED]: '#4194A0',
  [STATUS_AT_CLIENT]: '#E4B34B',
  [STATUS_APPROVED]: '#00875A',
  [STATUS_POSTED]: '#8777D9',
  [STATUS_REJECTED]: '#DE350B',
  [STATUS_REJECTED_BY_CLIENT]: '#DE350B',
  [STATUS_COMPLETED]: '#2C5DE5',
  [STATUS_DRAFT]: '#7A869A',
  [STATUS_EXPORT_FAILED]: '#de1c22',
};
module.exports.STATUS_COLOR = STATUS_COLOR;

var STATUS_LABEL = {
  [STATUS_WAITING_FOR]: 'Assigned',
  [STATUS_DONE]: 'Done',
  [STATUS_WAITING_FOR_INTERNAL_APPROVAL]: 'Pending internal approval',
  [STATUS_INTERNAL_APPROVED]: 'Internally approved',
  [STATUS_AT_CLIENT]: 'Pending client approval',
  [STATUS_APPROVED]: 'Approved by client',
  [STATUS_POSTED]: 'Posted',
  [STATUS_REJECTED]: 'Internal rework',
  [STATUS_REJECTED_BY_CLIENT]: 'Client rework',
  [STATUS_COMPLETED]: 'Draft',
  [STATUS_DRAFT]: 'Private draft',
  [STATUS_EXPORT_FAILED]: 'Export failed',
  [STATUS_IS_SCHEDULING]: 'Scheduling',
  [STATUS_SCHEDULED]: 'Scheduled',
  [STATUS_EXPORTED]: 'Exported',
  [STATUS_FAILED]: 'Failed',
};
module.exports.STATUS_LABEL = STATUS_LABEL;

var STATUSES_VISIBLE_BY_CLIENT = [
  STATUS_AT_CLIENT,
  STATUS_REJECTED_BY_CLIENT,
  STATUS_APPROVED,
  STATUS_POSTED,
  STATUS_EXPORT_FAILED,
  STATUS_IS_SCHEDULING,
  STATUS_EXPORTED,
];
module.exports.STATUSES_VISIBLE_BY_CLIENT = STATUSES_VISIBLE_BY_CLIENT;

var STATUSES_VISIBLE_BY_MANAGER = [
  STATUS.DRAFT,
  STATUS.COMPLETED,
  STATUS.WAITING_FOR,
  STATUS.DONE,
  STATUS.WAITING_FOR_INTERNAL_APPROVAL,
  STATUS.REJECTED,
  STATUS.INTERNAL_APPROVED,
  STATUS.AT_CLIENT,
  STATUS.APPROVED,
  STATUS.REJECTED_BY_CLIENT,
  STATUS.POSTED,
  STATUS_EXPORT_FAILED,
  STATUS_IS_SCHEDULING,
  STATUS_EXPORTED,
];
module.exports.STATUSES_VISIBLE_BY_MANAGER = STATUSES_VISIBLE_BY_MANAGER;

var STATUSES_VISIBLE_BY_DESIGNER = [
  STATUS.COMPLETED,
  STATUS.WAITING_FOR,
  STATUS.DONE,
  STATUS.WAITING_FOR_INTERNAL_APPROVAL,
  STATUS.AT_CLIENT,
  STATUS.APPROVED,
  STATUS.INTERNAL_APPROVED,
  STATUS.REJECTED,
  STATUS.REJECTED_BY_CLIENT,
  STATUS.POSTED,
  STATUS_EXPORT_FAILED,
  STATUS_IS_SCHEDULING,
  STATUS_EXPORTED,
];
module.exports.STATUSES_VISIBLE_BY_DESIGNER = STATUSES_VISIBLE_BY_DESIGNER;

var STATUSES_VISIBLE_BY_TRANSLATOR = [
  STATUS.WAITING_FOR,
  STATUS.DONE,
  STATUS.WAITING_FOR_INTERNAL_APPROVAL,
  STATUS.REJECTED,
  STATUS.REJECTED_BY_CLIENT,
  STATUS.INTERNAL_APPROVED,
];
module.exports.STATUSES_VISIBLE_BY_TRANSLATOR = STATUSES_VISIBLE_BY_TRANSLATOR;

var STATUSES_VISIBLE_BY_MEDIA_AGENCY = [
  STATUS.AT_CLIENT,
  STATUS.APPROVED,
  STATUS.POSTED,
  STATUS_EXPORT_FAILED,
  STATUS_IS_SCHEDULING,
  STATUS_EXPORTED,
];
module.exports.STATUSES_VISIBLE_BY_MEDIA_AGENCY = STATUSES_VISIBLE_BY_MEDIA_AGENCY;

var PREVIEW_DESKTOP_FEED_STANDARD = 'DESKTOP_FEED_STANDART';
module.exports.PREVIEW_DESKTOP_FEED_STANDARD = PREVIEW_DESKTOP_FEED_STANDARD;

var PREVIEW_MOBILE_FEED_STANDARD = 'MOBILE_FEED_STANDART';
module.exports.PREVIEW_MOBILE_FEED_STANDARD = PREVIEW_MOBILE_FEED_STANDARD;

var PREVIEW_MOBILE_FEED_BASIC = 'MOBILE_FEED_BASIC';
module.exports.PREVIEW_MOBILE_FEED_BASIC = PREVIEW_MOBILE_FEED_BASIC;

var FACEBOOK_PREVIEW = {
  DESKTOP_FEED_STANDARD: PREVIEW_DESKTOP_FEED_STANDARD,
  MOBILE_FEED_STANDART: PREVIEW_MOBILE_FEED_STANDARD,
  MOBILE_FEED_BASIC: PREVIEW_MOBILE_FEED_BASIC,
};
module.exports.FACEBOOK_PREVIEW = FACEBOOK_PREVIEW;

var STATUSES_ALLOWED_FOR_TASK_ASSIGNMENT = [
  STATUS.INTERNAL_APPROVED,
  STATUS.APPROVED,
  STATUS.WAITING_FOR,
  STATUS.REJECTED,
  STATUS.REJECTED_BY_CLIENT,
  STATUS.COMPLETED,
  STATUS.DONE
];
module.exports.STATUSES_ALLOWED_FOR_TASK_ASSIGNMENT = STATUSES_ALLOWED_FOR_TASK_ASSIGNMENT;

var STATUSES_ALLOWED_FOR_EXPORT_TO_SOCIAL_MEDIA = [
  STATUS.APPROVED,
  STATUS.INTERNAL_APPROVED,
  STATUS.COMPLETED,
  STATUS.DONE,
];
module.exports.STATUSES_ALLOWED_FOR_EXPORT_TO_SOCIAL_MEDIA = STATUSES_ALLOWED_FOR_EXPORT_TO_SOCIAL_MEDIA;

var STATUSES_ALLOWED_FOR_SEND_TO_INTERNAL_APPROVAL = [
  STATUS.DONE,
  STATUS.COMPLETED,
  STATUS.INTERNAL_APPROVED,
  STATUS.REJECTED_BY_CLIENT,
  STATUS.REJECTED,
  STATUS.APPROVED,
];
module.exports.STATUSES_ALLOWED_FOR_SEND_TO_INTERNAL_APPROVAL = STATUSES_ALLOWED_FOR_SEND_TO_INTERNAL_APPROVAL;

var STATUSES_ALLOWED_FOR_SEND_TO_CLIENT_APPROVAL = [
  STATUS.DONE,
  STATUS.COMPLETED,
  STATUS.INTERNAL_APPROVED,
  STATUS.REJECTED_BY_CLIENT,
  STATUS.REJECTED,
  STATUS.APPROVED,
];
module.exports.STATUSES_ALLOWED_FOR_SEND_TO_CLIENT_APPROVAL = STATUSES_ALLOWED_FOR_SEND_TO_CLIENT_APPROVAL;

var STATUSES_ALLOWED_FOR_CONVERT_PRIVATE_DRAFT_TO_DRAFT = [
  STATUS.DRAFT
];
module.exports.STATUSES_ALLOWED_FOR_CONVERT_PRIVATE_DRAFT_TO_DRAFT = STATUSES_ALLOWED_FOR_CONVERT_PRIVATE_DRAFT_TO_DRAFT;

var STATUSES_ALLOWED_FOR_CONVERT_WAITING_FOR_TO_DONE = [
  STATUS.WAITING_FOR
];
module.exports.STATUSES_ALLOWED_FOR_CONVERT_WAITING_FOR_TO_DONE = STATUSES_ALLOWED_FOR_CONVERT_WAITING_FOR_TO_DONE;

var STATUSES_ALLOWED_FOR_INTERNAL_APPROVAL = [
  STATUS.WAITING_FOR_INTERNAL_APPROVAL
];
module.exports.STATUSES_ALLOWED_FOR_INTERNAL_APPROVAL = STATUSES_ALLOWED_FOR_INTERNAL_APPROVAL;

var STATUSES_ALLOWED_FOR_CLIENT_APPROVAL = [
  STATUS.AT_CLIENT,
  STATUS.APPROVED,
  STATUS_REJECTED_BY_CLIENT,
];
module.exports.STATUSES_ALLOWED_FOR_CLIENT_APPROVAL = STATUSES_ALLOWED_FOR_CLIENT_APPROVAL;
